import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES, BLOCKS } from '@contentful/rich-text-types';
import React from 'react';
import { PrimaryButton, SecondaryButton, TertiaryButton } from '../../button';
import Link from 'next/link';

function renderOptions(links: any) {
  // create an asset map
  const assetMap = new Map();
  // loop through the assets and add them to the map
  for (const asset of links.assets.block) {
    assetMap.set(asset.sys.id, asset);
  }

  // create an entry map
  const entryMap = new Map();
  // loop through the block linked entries and add them to the map
  for (const entry of links.entries.block) {
    entryMap.set(entry.sys.id, entry);
  }

  // loop through the inline linked entries and add them to the map
  for (const entry of links.entries.inline) {
    entryMap.set(entry.sys.id, entry);
  }

  return {
    renderNode: {
      [INLINES.HYPERLINK]: (node: any, children: any) => (
        <a
          className="link"
          href={node.data.uri}
          target="_blank"
          rel="noreferrer"
        >
          {children}
        </a>
      ),
      [BLOCKS.EMBEDDED_ENTRY]: (node: any) => {
        // find the entry in the entryMap by ID
        const entry = entryMap.get(node.data.target.sys.id);

        // render the entries as needed by looking at the __typename
        if (entry.__typename === 'ComponentButton') {
          switch (entry.buttonVariant) {
            case 'Primary':
              return (
                <Link href={entry.url || '#'}>
                  <PrimaryButton>{entry.label}</PrimaryButton>
                </Link>
              );
            case 'Secondary':
              return (
                <Link href={entry.url || '#'}>
                  <SecondaryButton>{entry.label}</SecondaryButton>
                </Link>
              );
            case 'Tertiary':
              return (
                <Link href={entry.url || '#'}>
                  <TertiaryButton>{entry.label}</TertiaryButton>
                </Link>
              );
            default:
              return (
                <Link href={entry.url || '#'}>
                  <PrimaryButton>{entry.label}</PrimaryButton>
                </Link>
              );
          }
        }

        return null;
      },
    },
  };
}

const createRichTextPanel = (content: any) => {
  return documentToReactComponents(
    content?.json,
    renderOptions(content?.links)
  );
};

export default createRichTextPanel;
